import { useRef, useCallback } from 'react';

function useDebouncedCallback(callback, delay) {
	const timeoutRef = useRef(null);

	const debouncedCallback = useCallback(
		(...args) => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
			timeoutRef.current = setTimeout(() => {
				callback(...args);
			}, delay);
		},
		[callback, delay]
	);

	return debouncedCallback;
}

export default useDebouncedCallback;
